import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("hb_token");
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await api.me();
      setUser(data.user);
    } catch {
      localStorage.removeItem("hb_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.login({ email, password });
    localStorage.setItem("hb_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password, extras = {}) => {
    const { data } = await api.register({ name, email, password, ...extras });
    localStorage.setItem("hb_token", data.token);
    setUser(data.user);
    return data; // includes { user, token, school, magic_link_sent_to }
  };

  const logout = () => {
    localStorage.removeItem("hb_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
